exports["UK"] = require("./UK.js");
exports["UA"] = require("./UA.js");
exports["AM"] = require("./AM.js");
exports["ES"] = require("./ES.js");
exports["SE"] = require("./SE.js");
exports["AL"] = require("./AL.js");
exports["RS"] = require("./RS.js");
exports["NO"] = require("./NO.js");
exports["PL"] = require("./PL.js");